import React, { useState } from 'react';
import { Code, Menu, X, Bell, Plus, ChevronDown } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-[#24292f] text-white py-3 px-4 md:px-6 border-b border-[#d0d7de]/10" data-id="element-74">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between" data-id="element-75">
        {/* Left Section: Logo & Mobile Menu */}
        <div className="flex items-center gap-4" data-id="element-76">
          <button className="md:hidden text-gray-300 hover:text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-77">
            {isMenuOpen ? <X size={24} data-id="element-78" /> : <Menu size={24} data-id="element-79" />}
          </button>

          <a href="#" className="flex items-center gap-2 text-white font-bold text-lg hover:text-gray-300 transition-colors" data-id="element-80">
            <div className="bg-white text-[#24292f] p-1 rounded-full" data-id="element-81">
              <Code size={20} data-id="element-82" />
            </div>
            <span className="hidden sm:inline" data-id="element-83">Code Vanta</span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1 ml-4 text-sm font-semibold" data-id="element-84">
            <div className="relative group" data-id="element-85">
              <button className="px-2 py-1 text-gray-300 hover:text-white flex items-center gap-1" data-id="element-86">
                Product <ChevronDown size={14} data-id="element-87" />
              </button>
            </div>
            <a href="#services" className="px-2 py-1 text-gray-300 hover:text-white" data-id="element-88">
              Services
            </a>
            <a href="#projects" className="px-2 py-1 text-gray-300 hover:text-white" data-id="element-89">
              Open Source
            </a>
            <a href="#about" className="px-2 py-1 text-gray-300 hover:text-white" data-id="element-90">
              About
            </a>
          </nav>
        </div>

        {/* Right Section: Search & Actions */}
        <div className="flex items-center gap-3" data-id="element-91">
          <div className="hidden md:block relative" data-id="element-92">
            <div className="flex items-center border border-[#57606a] rounded-md bg-[#24292f] overflow-hidden focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500 w-64 transition-all" data-id="element-93">
              <span className="pl-2 text-gray-400 text-xs border-r border-[#57606a] pr-1" data-id="element-94">
                /
              </span>
              <input type="text" placeholder="Search or jump to..." className="bg-transparent border-none text-sm text-white placeholder-gray-400 px-2 py-1 focus:outline-none w-full" data-id="element-95" />
              <span className="pr-2 text-gray-400 text-xs border border-[#57606a] rounded px-1 mx-1 hidden lg:block" data-id="element-96">
                k
              </span>
            </div>
          </div>

          <div className="flex items-center gap-2 md:gap-4" data-id="element-97">
            <button className="text-gray-300 hover:text-white hidden sm:block" data-id="element-98">
              <span className="text-sm font-semibold" data-id="element-99">Sign in</span>
            </button>
            <button className="text-gray-300 hover:text-white border border-[#57606a] rounded-md px-3 py-1 text-sm font-semibold hidden sm:block" data-id="element-100">
              Sign up
            </button>

            {/* Mobile Search Icon */}
            <button className="md:hidden text-gray-300" data-id="element-101">
              <span className="sr-only" data-id="element-102">Search</span>
              <svg aria-hidden="true" height="20" viewBox="0 0 16 16" version="1.1" width="20" data-view-component="true" className="fill-current" data-id="element-103">
                <path d="M10.68 11.74a6 6 0 0 1-7.922-8.982 6 6 0 0 1 8.982 7.922l3.04 3.04a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215ZM11.5 7a4.499 4.499 0 1 0-8.997 0A4.499 4.499 0 0 0 11.5 7Z" data-id="element-104"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && <div className="md:hidden mt-3 pt-3 border-t border-[#57606a] px-2 space-y-2 pb-4" data-id="element-105">
          <input type="text" placeholder="Search Code Vanta..." className="w-full bg-[#24292f] border border-[#57606a] rounded-md px-3 py-2 text-white placeholder-gray-400 mb-4" data-id="element-106" />
          <a href="#services" className="block py-2 text-white font-semibold border-b border-[#57606a]" data-id="element-107">
            Services
          </a>
          <a href="#projects" className="block py-2 text-white font-semibold border-b border-[#57606a]" data-id="element-108">
            Open Source
          </a>
          <a href="#about" className="block py-2 text-white font-semibold border-b border-[#57606a]" data-id="element-109">
            About
          </a>
          <div className="pt-2 flex flex-col gap-2" data-id="element-110">
            <Button className="w-full justify-center text-white border-gray-500" data-id="element-111">
              Sign in
            </Button>
            <Button className="w-full justify-center text-white border-gray-500" data-id="element-112">
              Sign up
            </Button>
          </div>
        </div>}
    </header>;
}